(function(){
  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  var drawer=qs('#DeliveryDrawer'); if(!drawer) return;
  var panel=qs('.delivery-drawer__panel',drawer);
  var openers=qsa('.delivery-open'); var closers=qsa('[data-delivery-close]',drawer);

  function openDrawer(e){
    if(e) e.preventDefault();
    drawer.hidden=false;
    requestAnimationFrame(function(){
      drawer.classList.add('is-open');
      panel.focus({preventScroll:true});
      openers.forEach(function(o){o.setAttribute('aria-expanded','true')});
    });
    document.documentElement.style.overflow='hidden';
  }
  function closeDrawer(){
    drawer.classList.remove('is-open');
    setTimeout(function(){
      drawer.hidden=true;
      document.documentElement.style.overflow='';
      openers.forEach(function(o){o.setAttribute('aria-expanded','false')});
    },350);
  }

  openers.forEach(function(o){
    o.addEventListener('click',openDrawer);
    o.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')openDrawer(e)});
  });
  closers.forEach(function(b){b.addEventListener('click',closeDrawer)});
  drawer.addEventListener('click',function(e){if(e.target.matches('.delivery-drawer__overlay'))closeDrawer()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('is-open'))closeDrawer()});
})();

